import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const PlaybookCTA = () => (
  <section className="relative py-14 lg:py-16" data-testid="playbook-cta-section">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, x: -80 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="flex flex-wrap items-center gap-6 border border-[#2A2D34] bg-[#111317] p-6 lg:gap-10 lg:px-10 lg:py-7"
      >
        <motion.img
          initial={{ opacity: 0, x: -40, rotate: -10 }}
          whileInView={{ opacity: 1, x: 0, rotate: -2 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
          src="/images/playbook-book.jpg"
          alt="The Client Magnet Playbook"
          loading="lazy"
          decoding="async"
          data-testid="playbook-cta-image"
          className="hidden h-32 w-24 shrink-0 border border-[#2A2D34] object-cover shadow-lg sm:block"
          style={{ objectPosition: "50% 58%" }}
        />
        <div className="min-w-0 flex-1">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#C6FF00] lime-text-glow">Not ready for an audit yet?</p>
          <h2 className="mt-2 text-xl font-black uppercase tracking-tight text-white lg:text-2xl">Start with the Client Magnet Playbook</h2>
          <p className="mt-1 max-w-xl text-sm font-medium text-[#8A939B]">21 real secrets &amp; hacks to appeal to your target audience — free, instant download. When you're ready to see what's holding <span className="text-white">your</span> business back, the <Link to="/brand-audit" className="font-bold text-[#C6FF00] hover:underline">free Brand Audit</Link> is the real unlock.</p>
        </div>
        <Link
          to="/playbook"
          data-testid="home-playbook-btn"
          className="inline-flex shrink-0 items-center gap-2 rounded-full border border-[#2A2D34] px-7 py-3.5 text-sm font-bold uppercase tracking-wider text-white transition-colors duration-300 hover:border-[#C6FF00] hover:text-[#C6FF00]"
        >
          Get The Free Playbook <ArrowUpRight className="h-4 w-4" strokeWidth={2.5} />
        </Link>
      </motion.div>
    </div>
  </section>
);
